<template>
  <generic-form v-slot="{ data }" :endpoints="endpoints" targetClass="md-size-100" :creationEnabled="false">
    <md-table v-fixedTableHeader v-bind:value="data" v-withKeyboard>
      <md-table-row slot="md-table-row" slot-scope="{ item, index }">
        <md-table-cell md-label="Hierarchy">
          <backend-text v-model="item.order" labelClass="no-asterisk" rules="required|numeric"></backend-text>
        </md-table-cell>
        <md-table-cell md-label="Name">
          <backend-text v-model="item.name" labelClass="no-asterisk" rules="required"></backend-text>
        </md-table-cell>
        <md-table-cell md-label="Acronym">
          <backend-text v-model="item.acronym" labelClass="no-asterisk" rules="required"></backend-text>
        </md-table-cell>
        <md-table-cell md-label="Default">
          <md-radio @change="setDefault(data, index)" v-bind:value="!item.default">Default</md-radio>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </generic-form>
</template>

<script>
import Api from '../../../../openapi/src/api/RoomTypeApi.js'
import RoomTypeDTO from '../../../../openapi/src/model/RoomTypeDTO.js'
import BackendText from '../../Components/Inputs/BackendText.vue'
import GenericForm from '../GenericForm.vue'

export default {
  components: {
    GenericForm,
    BackendText,
  },
  data() {
    const api = new Api()
    const vm = this

    return {
      endpoints: {
        get: api.getRoomTypes.bind(api, vm.$root.hotelId),
        update: api.updateRoomTypes.bind(api),
      },
    }
  },
  methods: {
    setDefault(data, index) {
      data.forEach((d) => (d.default = false))
      data[index].default = true
    },
    isDefault(data, index) {
      return data[index].default
    },
    constructNewItemFromObject(data) {
      return RoomTypeDTO.constructFromObject(Object.assign(RoomTypeDTO.prototype, data))
    },
  },
}
</script>
